export const iconFontAwesomeDisasterCrisisCloudBolt = (
	<i className="fa-solid fa-cloud-bolt"></i>
);
